export const style = {
  Typography: {
    sx: {
      color: 'action.active',
      fontSize: 20,
      pr: 1,
    },
  },
  // TextField: {
  //   sx: {
  //     '& .MuiInputLabel-formControl': {
  //       color: 'text.primary',
  //       fontWeight: 500,
  //     },
  //     '& input': {
  //       fontWeight: 400,
  //     },
  //   },
  // },
} as const;
